import { ContactProps } from './Contact';
import { ProgramNames } from './Program';
import { UserProps } from './User';

export interface ReviewerProps {
  email: string;
  assignment: ReviewerAssignmentProps;
  user: UserProps;
}

export interface ReviewerAssignmentProps {
  email?: string;
  programId?: ProgramNames;
  stateId: string;
  countryId: number;
  countyId: string;
  user?: UserProps;
}

export interface ReviewerContactProps {
  contact: ContactProps;
  reviewerType: ReviewerTypes;
}

export enum ReviewerTypes {
  Adf = 1,
  Regional = 2,
  State = 3,
  International = 4,
}

export type { ReviewerDashboardProps } from './ReviewerDashboard';
